import { useAuth } from "@workos-inc/authkit-react";
import { isNarrativeEasterEggEnabled } from "./featureFlag";

export interface NarrativeEasterEggState {
  enabled: boolean;
  loaded: boolean;
}

export function useNarrativeEasterEggEnabled(): NarrativeEasterEggState {
  const { featureFlags, isLoading } = useAuth();
  return {
    enabled: isNarrativeEasterEggEnabled(featureFlags),
    loaded: !isLoading,
  };
}
